import { render, staticRenderFns } from "./userDashboardNutritionCalendar.vue?vue&type=template&id=42b239f1"
import script from "./userDashboardNutritionCalendar.vue?vue&type=script&lang=js"
export * from "./userDashboardNutritionCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports